export const MODULE_NAME = 'POPUP_CREATE_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const POPUP_CREATE_MODULE_NAME = 'POPUP_CREATE_MODULE_NAME';

export const API = {
  TYPE: 'POST',
  URL: '/popup/create',
};

export enum FORM_VALUE_ENUM {
  LINK_URL = 'linkUrl',
  IMG_URL = 'imgUrl',
  BODY = 'body',
  DEADLINE = 'deadline',
  LANG = 'lang',
}

export type FORM_VALUE_TYPE = `${FORM_VALUE_ENUM}`;

export interface SELECT_INTER {
  value: number;
  label: string;
}

export interface FORM_VALUE_INTER {
  [FORM_VALUE_ENUM.BODY]: string;
  [FORM_VALUE_ENUM.LANG]: SELECT_INTER[];
  [FORM_VALUE_ENUM.LINK_URL]: string;
  [FORM_VALUE_ENUM.IMG_URL]: string;
  [FORM_VALUE_ENUM.DEADLINE]: string;
}
